module.exports = __webpack_public_path__ + "media/markers/marker-cluster-red-81d49d44.svg";